export default __webpack_public_path__ + "static/media/copyicon.1d75039f.svg";